export function renderNewProjectPage(): string {
  return `
    <section class="screen">
      <header class="topbar">
        <button class="ghost-button" data-action="back-to-list">返回</button>
        <h1>新建项目</h1>
      </header>
      <form id="new-project-form" class="panel stack">
        <label class="field">
          <span>项目名称</span>
          <input name="projectName" type="text" placeholder="例如：XX商业综合体消防验收项目" maxlength="80" required />
        </label>
        <button class="primary-button" type="submit">创建项目</button>
      </form>
    </section>
  `;
}
